import { type AppKit, createAppKit } from '@reown/appkit'
import { metadata, networks } from '@/config/hedera'
import { HASH_PACK_WALLET_ID, HEDERA_MAINNET, IS_PRODUCTION, WC_PROJECT_ID } from '@/config/constants'
import {
  HederaAdapter,
  HederaChainDefinition,
  HederaJsonRpcMethod,
  hederaNamespace,
  HederaProvider,
} from '@hashgraph/hedera-wallet-connect'
import type UniversalProvider from '@walletconnect/universal-provider'

let universalProvider: UniversalProvider | null = null

const hederaMethods = Object.values(HederaJsonRpcMethod)

export const resetHederaProvider = () => {
  universalProvider = null
}

export const getHederaProvider = () => universalProvider as unknown as HederaProvider | null

export const createHederaAppKit = async (themeMode: 'light' | 'dark', targetChainId?: string) => {
  const isTargetMainnet = targetChainId === HEDERA_MAINNET
  const chains: [string, string] = isTargetMainnet
    ? ['hedera:mainnet', 'hedera:testnet']
    : ['hedera:testnet', 'hedera:mainnet']

  if (!universalProvider)
    universalProvider = (await HederaProvider.init({
      projectId: WC_PROJECT_ID,
      metadata,
      logger: IS_PRODUCTION ? undefined : 'debug',
      optionalNamespaces: {
        hedera: {
          methods: hederaMethods,
          chains,
          events: ['chainChanged', 'accountsChanged'],
        },
      },
    } as any)) as unknown as UniversalProvider

  const defaultNetwork = isTargetMainnet ? HederaChainDefinition.Native.Mainnet : HederaChainDefinition.Native.Testnet

  const nativeHederaAdapter = new HederaAdapter({
    projectId: WC_PROJECT_ID,
    networks: [HederaChainDefinition.Native.Mainnet, HederaChainDefinition.Native.Testnet],
    namespace: hederaNamespace,
  })

  const appKitInstance: AppKit = createAppKit({
    adapters: [nativeHederaAdapter],
    universalProvider,
    defaultNetwork,
    projectId: WC_PROJECT_ID,
    metadata,
    networks,
    themeMode,
    enableReconnect: true,
    includeWalletIds: [HASH_PACK_WALLET_ID],
    allWallets: 'HIDE',
    features: {
      analytics: true,
      socials: false,
      swaps: false,
      onramp: false,
      email: false,
    },
  })

  return appKitInstance
}
